import { SET_ZAP_RPU_PERIODS_MODAL_OPEN_STATUS } from '../actionTypes';
import { actions } from '../reducer';

export default (isOpen) =>
    actions[SET_ZAP_RPU_PERIODS_MODAL_OPEN_STATUS](isOpen);
